import { gql } from "@apollo/client";

const MARKETING_WORKSPACE_FIELDS = `
  id
  name
  plan
  role
  isOwner
  createdAt
`;

export const GET_MY_MARKETING_WORKSPACES = gql`
  query GetMyMarketingWorkspaces {
    myMarketingWorkspaces {
      ${MARKETING_WORKSPACE_FIELDS}
    }
  }
`;

export const GET_MARKETING_WORKSPACE = gql`
  query GetMarketingWorkspace($id: String!) {
    marketingWorkspace(id: $id) {
      ${MARKETING_WORKSPACE_FIELDS}
    }
  }
`;

export const CREATE_MARKETING_WORKSPACE = gql`
  mutation CreateMarketingWorkspace($request: CreateMarketingWorkspaceInput!) {
    createMarketingWorkspace(request: $request) {
      ${MARKETING_WORKSPACE_FIELDS}
    }
  }
`;

export const UPDATE_MARKETING_WORKSPACE = gql`
  mutation UpdateMarketingWorkspace($id: String!, $request: UpdateMarketingWorkspaceInput!) {
    updateMarketingWorkspace(id: $id, request: $request) {
      ${MARKETING_WORKSPACE_FIELDS}
    }
  }
`;

export const DELETE_MARKETING_WORKSPACE = gql`
  mutation DeleteMarketingWorkspace($id: String!) {
    deleteMarketingWorkspace(id: $id)
  }
`;
